import { Box, Container, Stack, Typography } from "@mui/material";
import CustomerSubscriptions from "Modules/Customer/CustomerSubscriptions"

function CustomerSubscriptionModule() {
    return (
        <Container sx={{
            margin: 0,
            maxWidth: '100% !important'
        }}>
        <Stack direction="column" sx={{  flex : 1 }}>
            <Stack direction="row" justifyContent="space-between">
                        {/* onChange={onSearchTextChange} value={filter} onKeyUp={searchKeyHandler}  */}
                <Box sx={{ width: 'fit-content' }}>
                    <Typography variant="h1">Customer Subscriptions</Typography>
                </Box>
            </Stack>
            <Box sx={{ height: '100%', flex: 1, display: 'flex' }}>
                <div className=" MainPanel--wrapper ModulePanel--wrapper CustomerData--wrapper">
                    <CustomerSubscriptions />
                </div>
            </Box>
        </Stack>
        </Container>
    )
}

export default CustomerSubscriptionModule;